import { useGetACHIncomingExpectedQuery } from 'API/accounting/AccountingApi';
import React from 'react';
import { ISearchQuery } from './ISearchQuery';
import { SpinnerTW } from 'tailwindComponents/spinnerTW/SpinnerTW';
import { IPotentialMatch } from './IPotentialMatch';
import { ExpectedACHTableDisplay } from './ExpectedACHTableDisplay';

export interface IExpectedACHSearchProps {
  query: ISearchQuery;
  accountNumber: string;
  setPotentialMatch: (x: IPotentialMatch) => void;
}

export const ExpectedACHSearch: React.FC<IExpectedACHSearchProps> = ({ query, setPotentialMatch, accountNumber }) => {
  const { data, isLoading } = useGetACHIncomingExpectedQuery(query);
  return (
    <>
      {isLoading && <SpinnerTW />}
      {!!data?.content.length && (
        <ExpectedACHTableDisplay data={data} setPotentialMatch={setPotentialMatch} accountNumber={accountNumber} />
      )}
    </>
  );
};
